<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <!-- 부가정보 : 사업개요 정보-->
    <write-grid-container title="사업개요 정보" v-model="form.subInfo" :options="gridContainerOptions" class="mt-7">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-input">{{ form.subInfo[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <custom-option-selector v-if="dataType === 'selector'" class="w-full" v-model="form.subInfo[value]" :options="result_options1" @input="onInputSelector" />
          <custom-option-selector v-else-if="dataType === 'selector2'" class="w-full" v-model="form.subInfo[value]" :options="result_options2" />
          <number-input v-else-if="dataType === 'number'" class="w-full" ro ws="5" v-model="form.subInfo[value]" :max="9999" />
          <DateSelector v-else-if="dataType === 'date'" class="w-full" v-model="form.subInfo[value]" />
          <ml-input v-else class="w-full" v-model="form.subInfo[value]" visible-counter />
        </div>
      </template>
    </write-grid-container>

    <!-- 파일첨부 -->
    <FileDownloadPost :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" title="파일첨부" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";

import FileDownloadPost from "@/components/FileDownloadPost.vue";
import NumberInput from "@/components/NumberInput.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector";

import { required } from "vuelidate/lib/validators";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    WriteGridContainer,
    FileDownloadPost,
    NumberInput,
    DateSelector,
    CustomOptionSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
    },
  },
  data() {
    return {
      result_options1: ["410. 안전운전절차서", "420. 설비점검정비유지관리", "430. 안전작업허가", "440. 도급업체 안전관리", "450. 안전보건교육", "460. 가동전 점검", "470. 변경요소 관리 절차서", "480. 자체감사", "490. 공정사고 조사"],
      result_options2: [],
      data_result_options2: {
        "410. 안전운전절차서": ["설비당 안전운전절차서", "해당없음"],
        "420. 설비점검정비유지관리": ["설비별 내구 연한 기준", "알람 및 인터록관리 지침", "해당없음"],
        "430. 안전작업허가": ["안전작업허가서 지침", "해당없음"],
        "440. 도급업체 안전관리": ["도급업체 안전관리 지침", "해당없음"],
        "450. 안전보건교육": ["안전보건교육 지침", "해당없음"],
        "460. 가동전 점검": ["가동전 점검 지침", "가동전 점검 보고서 별도 파일링", "해당없음"],
        "470. 변경요소 관리 절차서": ["변경요소 관리 지침", "변경관리 별도 파일링", "해당없음"],
        "480. 자체감사": ["자체감사 계획 지침", "자체감사 실적 별도 파일링", "해당없음"],
        "490. 공정사고 조사": ["공정사고 조사 지침", "해당없음"],
      },
      gridContainerOptions: {
        dataTypes: ["string", "selector", "selector2", "number", "date"],
        labels: ["공장명", "구분1", "구분2", "Rev", "제개정일"],
        values: ["공장명", "구분1", "구분2", "Rev", "제개정일"],
      },
      form: {
        stdInfo: {},
        fileList: [],
        subInfo: {},
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    // subInfo 초기화
    this.form.subInfo = this.gridContainerOptions.values.reduce((acc, cur) => {
      acc[cur] = "";
      return acc;
    }, {});

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    onInputSelector() {
      if (this.form.subInfo && this.form.subInfo["구분1"]) {
        this.form.subInfo["구분2"] = "";
        this.result_options2 = this.data_result_options2[this.form.subInfo["구분1"]];
      } else this.result_options2 = [];
    },
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "사업장명을 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@media print {
  .page-break {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}
</style>
